module.exports = __webpack_public_path__ + "static/media/BallMill.1241618e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/karna/BallMill.jpg
// module id = 395
// module chunks = 0